import { ImageBackground, View } from 'react-native'

import useDimension from '../../hooks/use-dimension'
import ModalOverlay from './ModalOverlay'

export type ModalProp = {
  isOpen: boolean
  onClose: () => void
  BgColor?: string
  children?: React.ReactNode
  childDelay?: number
}
export type BgStyle = { modalTp: number; bgW: number; bgH: number }

type Props = ModalProp & {
  bgImg: string
  styleProps: BgStyle
}

export default function ModalWrapper({
  isOpen,
  onClose,
  bgImg,
  BgColor,
  styleProps,
  children,
  childDelay = 0.2,
}: Props) {
  const { ws } = useDimension()

  const modalBg = bgImg
  const { modalTp, bgW, bgH } = styleProps

  if (!isOpen) return null

  return (
    <View
      style={{
        position: 'absolute',
        width: 360 * ws,
        minHeight: 640 * ws,
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 30,
      }}
    >
      {/* overlay  */}
      <ModalOverlay onClickFunc={onClose} bgColor={BgColor} />

      <View
        style={{
          position: 'absolute',
          top: modalTp * ws,
          alignItems: 'center',
        }}
      >
        <div
          className="ld ld-blur-in"
          style={{ animationDuration: '0.3s' }}
        >
          <ImageBackground
            source={{ uri: modalBg }}
            style={{
              position: 'relative',
              alignItems: 'center',
              width: bgW * ws,
              height: bgH * ws,
            }}
            resizeMode="contain"
            aria-label={`bg-modal`}
          >
            <div
              // className="ld ld-blur-in"
              style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                animationDuration: '0.3s',
                animationDelay: `${childDelay}s`,
              }}
            >
              {children}
            </div>
          </ImageBackground>
        </div>
      </View>
    </View>
  )
}
